// Stamp KPIs (top KPI row — /api/clickhouse/customer-reports/stamp-kpis)
export const FETCH_CUSTOMER_STAMP_KPIS_REQUEST = 'reports/customersReport/FETCH_CUSTOMER_STAMP_KPIS_REQUEST';
export const FETCH_CUSTOMER_STAMP_KPIS_SUCCESS = 'reports/customersReport/FETCH_CUSTOMER_STAMP_KPIS_SUCCESS';
export const FETCH_CUSTOMER_STAMP_KPIS_FAILURE = 'reports/customersReport/FETCH_CUSTOMER_STAMP_KPIS_FAILURE';

// Segment Breakdown (CUST-3.2 / 3.3 — /api/clickhouse/customer-reports/segment-breakdown-kpi)
export const FETCH_CUSTOMER_SEGMENTS_REQUEST = 'reports/customersReport/FETCH_CUSTOMER_SEGMENTS_REQUEST';
export const FETCH_CUSTOMER_SEGMENTS_SUCCESS = 'reports/customersReport/FETCH_CUSTOMER_SEGMENTS_SUCCESS';
export const FETCH_CUSTOMER_SEGMENTS_FAILURE = 'reports/customersReport/FETCH_CUSTOMER_SEGMENTS_FAILURE';

// Customer Directory (CUST-8.1 — /api/clickhouse/customer-reports/customer-directory-kpi)
export const FETCH_CUSTOMER_DIRECTORY_REQUEST = 'reports/customersReport/FETCH_CUSTOMER_DIRECTORY_REQUEST';
export const FETCH_CUSTOMER_DIRECTORY_SUCCESS = 'reports/customersReport/FETCH_CUSTOMER_DIRECTORY_SUCCESS';
export const FETCH_CUSTOMER_DIRECTORY_FAILURE = 'reports/customersReport/FETCH_CUSTOMER_DIRECTORY_FAILURE';

// Channel Performance (CUST-13.1 — /api/clickhouse/customer-reports/channel-performance-kpi)
export const FETCH_CHANNEL_PERFORMANCE_REQUEST = 'reports/customersReport/FETCH_CHANNEL_PERFORMANCE_REQUEST';
export const FETCH_CHANNEL_PERFORMANCE_SUCCESS = 'reports/customersReport/FETCH_CHANNEL_PERFORMANCE_SUCCESS';
export const FETCH_CHANNEL_PERFORMANCE_FAILURE = 'reports/customersReport/FETCH_CHANNEL_PERFORMANCE_FAILURE';

// Cohort Retention (CUST-11.1 — /api/clickhouse/customer-reports/cohort-retention-kpi)
export const FETCH_COHORT_RETENTION_REQUEST = 'reports/customersReport/FETCH_COHORT_RETENTION_REQUEST';
export const FETCH_COHORT_RETENTION_SUCCESS = 'reports/customersReport/FETCH_COHORT_RETENTION_SUCCESS';
export const FETCH_COHORT_RETENTION_FAILURE = 'reports/customersReport/FETCH_COHORT_RETENTION_FAILURE';

// Avg Spend by Segment (CUST-12.1 — /api/clickhouse/customer-reports/avg-spend-by-segment-kpi)
export const FETCH_SEGMENT_SPEND_REQUEST = 'reports/customersReport/FETCH_SEGMENT_SPEND_REQUEST';
export const FETCH_SEGMENT_SPEND_SUCCESS = 'reports/customersReport/FETCH_SEGMENT_SPEND_SUCCESS';
export const FETCH_SEGMENT_SPEND_FAILURE = 'reports/customersReport/FETCH_SEGMENT_SPEND_FAILURE';

// Drill-downs (CUST-5.1 / CUST-6 / CUST-2.2)
export const FETCH_DRILLDOWN_STATS_REQUEST = 'reports/customersReport/FETCH_DRILLDOWN_STATS_REQUEST';
export const FETCH_DRILLDOWN_STATS_SUCCESS = 'reports/customersReport/FETCH_DRILLDOWN_STATS_SUCCESS';
export const FETCH_DRILLDOWN_STATS_FAILURE = 'reports/customersReport/FETCH_DRILLDOWN_STATS_FAILURE';
export const FETCH_DRILLDOWN_CUSTOMERS_REQUEST = 'reports/customersReport/FETCH_DRILLDOWN_CUSTOMERS_REQUEST';
export const FETCH_DRILLDOWN_CUSTOMERS_SUCCESS = 'reports/customersReport/FETCH_DRILLDOWN_CUSTOMERS_SUCCESS';
export const FETCH_DRILLDOWN_CUSTOMERS_FAILURE = 'reports/customersReport/FETCH_DRILLDOWN_CUSTOMERS_FAILURE';

/* CUST-19.1 - customers by acquisition source. */
export const FETCH_ACQUISITION_SOURCE_REQUEST = 'reports/customersReport/FETCH_ACQUISITION_SOURCE_REQUEST';
export const FETCH_ACQUISITION_SOURCE_SUCCESS = 'reports/customersReport/FETCH_ACQUISITION_SOURCE_SUCCESS';
export const FETCH_ACQUISITION_SOURCE_FAILURE = 'reports/customersReport/FETCH_ACQUISITION_SOURCE_FAILURE';

/* CUST-7 / 16 / 17 - the row click, identical from either table. */
export const FETCH_CUSTOMER_DETAILS_REQUEST = 'reports/customersReport/FETCH_CUSTOMER_DETAILS_REQUEST';
export const FETCH_CUSTOMER_DETAILS_SUCCESS = 'reports/customersReport/FETCH_CUSTOMER_DETAILS_SUCCESS';
export const FETCH_CUSTOMER_DETAILS_FAILURE = 'reports/customersReport/FETCH_CUSTOMER_DETAILS_FAILURE';
export const CLEAR_CUSTOMER_DETAILS = 'reports/customersReport/CLEAR_CUSTOMER_DETAILS';
